export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION';
export const setCurrentLocation = locationId => ({
    type: SET_CURRENT_LOCATION,
    locationId,
});

export const RESET_CURRENT_LOCATION = 'RESET_CURRENT_LOCATION';
export const resetCurrentLocation = () => ({
    type: RESET_CURRENT_LOCATION,
});
